import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './admin-footer.component.html',
  styleUrls: ['./admin-footer.component.css'],
  selector: 'admin-footer'
 })
 
export class AdminFooterComponent implements OnInit { 
  theUser: string;
  
  constructor( private userSVC: UserService, private router: Router ){}

  ngOnInit(){
    this.theUser = this.userSVC.loggedInUser.email;
  }

  logout(){
    this.userSVC.logout();
    this.router.navigate(['']);
  }

  tagndoc(){
    this.router.navigate(['admin/tagndoc']);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/adminFooter/admin-footer.component.ts